import loadable from "@loadable/component";
import LinearProgress from "@material-ui/core/LinearProgress";

/**
 * Dynamically loaded version of `SystemLogsV2Page`.
 */
const LoadablePage = loadable(
  () => import(/* webpackChunkName: "SystemLogsV2Page" */ "."),
  {
    fallback: <LinearProgress />,
  }
);

export default LoadablePage;
